import { render, staticRenderFns } from "./AddToCartJustButton.vue?vue&type=template&id=0528e337"
import script from "./AddToCartJustButton.vue?vue&type=script&lang=js"
export * from "./AddToCartJustButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports